<!-- Summary Section -->
<nz-descriptions nzBordered *ngIf="!allData">
  <nz-descriptions-item [nzTitle]="'Item No.' | locale">
    {{itemCode}}
  </nz-descriptions-item>
  <nz-descriptions-item [nzTitle]="'Item Description' | locale">
    {{description}}
  </nz-descriptions-item>
  <nz-descriptions-item [nzTitle]="'Required Quantity' | locale">
    {{quantity}}
  </nz-descriptions-item>
  <nz-descriptions-item [nzTitle]="'Total Quantity In Stock' | locale">
    {{totalInStock}}
  </nz-descriptions-item>
  <nz-descriptions-item [nzTitle]="'Total Quantity On Purchase Order' | locale">
    {{totalOnPurchaseOrder}}
  </nz-descriptions-item>
  <nz-descriptions-item [nzTitle]="'Total Quantity On Backorder' | locale">
    {{totalOnBackOrder}}
  </nz-descriptions-item>
</nz-descriptions>

<div nz-row style="margin-bottom: 16px;margin-top: 10px;" *ngIf="!allData">
  <label nz-col nzSpan="20" style="display: flex !important;" nz-checkbox [ngModelOptions]="{standalone: true}"
    [(ngModel)]="isGrouped" (ngModelChange)="toggleGrouping($event)">Group Deliveries into
    Single
    Date</label>
  <button nz-col nzSpan="4" nz-button (click)="emitReButton()">
    {{ "Refresh" | locale }}
  </button>
</div>

<nz-table #scheduleTable *ngIf="!allData" [nzData]="scheduleSuggestions" nzBordered
  nzSize="middle">
  <thead>
    <tr>
      <th>Item Code</th>
      <th>Quantity</th>
      <th>Suggested Delivery Date</th>
      <th>User Delivery Date</th>
      <th>Status</th>
      <th>PO Numbers</th>
      <th>Actions</th>
    </tr>
  </thead>
  <tbody>
    <ng-container *ngFor="let suggestion of (isGrouped ? groupedSuggestions : scheduleSuggestions)">
      <tr>
        <td>{{ suggestion.ItemCode }}</td>
        <td>
          <nz-input-number [nzMin]="0" [nzMax]="suggestion.MaxQuantity" [(ngModel)]="suggestion.Quantity"
            (ngModelChange)="onQuantityChange()"
            [ngClass]="{ 'input-error': suggestion.Quantity < 0 || suggestion.Quantity > suggestion.MaxQuantity }"
            [disabled]="suggestion.IsBackOrder"></nz-input-number>
        </td>
        <td>{{ suggestion.DeliveryDate | date: dateFormat }}</td>
        <td>
          <nz-date-picker [nzFormat]="dateFormat" [(ngModel)]="suggestion.UserDeliveryDate"
            [nzDisabledDate]="disabledDate" (ngModelChange)="onDateChange(suggestion, $event)"></nz-date-picker>
        </td>
        <td>
          <ng-container [ngSwitch]="getStatus(suggestion)">
            <span *ngSwitchCase="'stock'" nz-tooltip nzTooltipTitle="From Stock">
              <i nz-icon nzType="database" nzTheme="twotone" nzTwoToneColor="#52c41a"></i>
            </span>
            <span *ngSwitchCase="'po'" nz-tooltip nzTooltipTitle="Based on Purchase Order">
              <i nz-icon nzType="shopping" nzTheme="twotone" nzTwoToneColor="#1890ff"></i>
            </span>
            <span *ngSwitchCase="'backorder'" nz-tooltip nzTooltipTitle="Backorder">
              <i nz-icon nzType="clock-circle" nzTheme="twotone" nzTwoToneColor="#faad14"></i>
            </span>
          </ng-container>
        </td>
        <td>
          <!-- Display PO Numbers -->
          <ng-container *ngIf="suggestion.PONumbers && suggestion.PONumbers.length > 0; else noPO">
            {{ suggestion.PONumbers.join(', ') }}
          </ng-container>
          <ng-template #noPO>
            N/A
          </ng-template>
        </td>
        <td>
          <button nz-button nzType="link" (click)="suggestion.showDetails = !suggestion.showDetails">
            {{ suggestion.showDetails ? 'Hide' : 'Show' }} Details
          </button>
        </td>
      </tr>
      <!-- Details Row -->
      <tr *ngIf="suggestion.showDetails">
        <td colspan="7">
          <!-- Component Allocations -->
          <ng-container *ngIf="suggestion.ComponentAllocations?.length">
            <nz-collapse>
              <nz-collapse-panel *ngFor="let compAlloc of suggestion.ComponentAllocations"
                [nzHeader]="'Component: ' + compAlloc.ComponentCode">
                <nz-list nzBordered>
                  <nz-list-item *ngFor="let poAlloc of compAlloc.POAllocations">
                    <nz-list-item-meta [nzTitle]="poAlloc.PONumber ? 'PO: ' + poAlloc.PONumber : 'Initial Stock'"
                      [nzDescription]="'Quantity Allocated: ' + poAlloc.QuantityAllocated"></nz-list-item-meta>
                  </nz-list-item>
                </nz-list>
              </nz-collapse-panel>
            </nz-collapse>
          </ng-container>
          <!-- Include PO Numbers if ComponentAllocations is null -->
          <ng-container
            *ngIf="!suggestion.ComponentAllocations?.length && suggestion.PONumbers && suggestion.PONumbers.length > 0">
            <p><strong>PO Numbers:</strong> {{ suggestion.PONumbers.join(', ') }}</p>
          </ng-container>
          <!-- Components Needed for Backorder -->
          <ng-container *ngIf="suggestion.IsBackOrder && suggestion.ComponentsToOrder">
            <p><strong>Components Needed for Backorder:</strong></p>
            <ul>
              <li *ngFor="let comp of getComponentsToOrderArray(suggestion.ComponentsToOrder)">
                {{ comp.ComponentCode }}: {{ comp.Quantity }}
              </li>
            </ul>
          </ng-container>
        </td>
      </tr>
    </ng-container>
  </tbody>
</nz-table>

<nz-table #scheduleTable *ngIf="allData" [nzData]="scheduleSuggestionsAll" nzBordered nzSize="middle">
  <thead>
    <tr>
      <th>#</th>
      <th>Item Code</th>
      <th>Quantity</th>
      <th>Suggested Delivery Date</th>
      <th>User Delivery Date</th>
      <th>Status</th>
      <th>PO Numbers</th>
      <th>Actions</th>
    </tr>
  </thead>
  <tbody>
    <ng-container *ngFor="let suggestion_all of scheduleSuggestionsAll">
      <ng-container *ngFor="let suggestion of suggestion_all">
        <tr>
          <td>{{ suggestion_all.lineIndex }}</td>
          <td>{{ suggestion.ItemCode }}</td>
          <td>
            <nz-input-number [nzMin]="0" [nzMax]="suggestion.MaxQuantity" [(ngModel)]="suggestion.Quantity"
              (ngModelChange)="onQuantityChange()"
              [ngClass]="{ 'input-error': suggestion.Quantity < 0 || suggestion.Quantity > suggestion.MaxQuantity }"
              [disabled]="true"></nz-input-number>
          </td>
          <td>{{ suggestion.DeliveryDate | date: dateFormat }}</td>
          <td>
            <nz-date-picker [disabled]="true" [nzFormat]="dateFormat" [(ngModel)]="suggestion.UserDeliveryDate"
              [nzDisabledDate]="disabledDate" (ngModelChange)="onDateChange(suggestion, $event)"></nz-date-picker>
          </td>
          <td>
            <ng-container [ngSwitch]="getStatus(suggestion)">
              <span *ngSwitchCase="'stock'" nz-tooltip nzTooltipTitle="From Stock">
                <i nz-icon nzType="database" nzTheme="twotone" nzTwoToneColor="#52c41a"></i>
              </span>
              <span *ngSwitchCase="'po'" nz-tooltip nzTooltipTitle="Based on Purchase Order">
                <i nz-icon nzType="shopping" nzTheme="twotone" nzTwoToneColor="#1890ff"></i>
              </span>
              <span *ngSwitchCase="'backorder'" nz-tooltip nzTooltipTitle="Backorder">
                <i nz-icon nzType="clock-circle" nzTheme="twotone" nzTwoToneColor="#faad14"></i>
              </span>
            </ng-container>
          </td>
          <td>
            <!-- Display PO Numbers -->
            <ng-container *ngIf="suggestion.PONumbers && suggestion.PONumbers.length > 0; else noPO">
              {{ suggestion.PONumbers.join(', ') }}
            </ng-container>
            <ng-template #noPO>
              N/A
            </ng-template>
          </td>
          <td>
            <button nz-button nzType="link" (click)="suggestion.showDetails = !suggestion.showDetails">
              {{ suggestion.showDetails ? 'Hide' : 'Show' }} Details
            </button>
          </td>
        </tr>
        <!-- Details Row -->
        <tr *ngIf="suggestion.showDetails">
          <td colspan="7">
            <!-- Component Allocations -->
            <ng-container *ngIf="suggestion.ComponentAllocations?.length">
              <nz-collapse>
                <nz-collapse-panel *ngFor="let compAlloc of suggestion.ComponentAllocations"
                  [nzHeader]="'Component: ' + compAlloc.ComponentCode">
                  <nz-list nzBordered>
                    <nz-list-item *ngFor="let poAlloc of compAlloc.POAllocations">
                      <nz-list-item-meta [nzTitle]="poAlloc.PONumber ? 'PO: ' + poAlloc.PONumber : 'Initial Stock'"
                        [nzDescription]="'Quantity Allocated: ' + poAlloc.QuantityAllocated"></nz-list-item-meta>
                    </nz-list-item>
                  </nz-list>
                </nz-collapse-panel>
              </nz-collapse>
            </ng-container>
            <!-- Include PO Numbers if ComponentAllocations is null -->
            <ng-container
              *ngIf="!suggestion.ComponentAllocations?.length && suggestion.PONumbers && suggestion.PONumbers.length > 0">
              <p><strong>PO Numbers:</strong> {{ suggestion.PONumbers.join(', ') }}</p>
            </ng-container>
            <!-- Components Needed for Backorder -->
            <ng-container *ngIf="suggestion.IsBackOrder && suggestion.ComponentsToOrder">
              <p><strong>Components Needed for Backorder:</strong></p>
              <ul>
                <li *ngFor="let comp of getComponentsToOrderArray(suggestion.ComponentsToOrder)">
                  {{ comp.ComponentCode }}: {{ comp.Quantity }}
                </li>
              </ul>
            </ng-container>
          </td>
        </tr>
      </ng-container>
    </ng-container>
  </tbody>
</nz-table>

<nz-space class="footer">
  <nz-space-item>
    <button nz-button nzType="primary" (click)="emitOkButton()">
      {{ 'OK' | locale }}
    </button>
  </nz-space-item>
  <!-- <nz-space-item *ngIf="!allData">
    <button nz-button (click)="emitReButton()">
      {{ 'Re-' | locale }}
    </button>
  </nz-space-item> -->
  <nz-space-item>
    <button nz-button (click)="emitCancelButton()">
      {{ "Cancel" | locale }}
    </button>
  </nz-space-item>
</nz-space>
